import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ImageDetail } from '@bookinglab/govbook-ui';
import { NavLink } from '@bookinglab/govbook-ui/layout';
import { HeaderComponent as GbHeaderComponent } from '@bookinglab/govbook-ui/layout';
import { DatastoreService } from '../../services';

@Component({
	selector: 'app-header',
	standalone: true,
	imports: [CommonModule, GbHeaderComponent],
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
	constructor(private datastoreService: DatastoreService) {}

	login() {
		window.open(
			'https://chapter.registrars.staging.bookinglab.co.uk/redbridge-staging/37043/access',
			'_blank'
		);
	}

	isAdmin() {
		return this.datastoreService.adminJourney;
	}
	imageDetail: ImageDetail = {
		alt: 'Redbridge Council Logo',
		src: 'assets/images/redbridge_logo.png',
	};

	navigation: NavLink[] = [
		{
			text: 'Ceremonies',
			url: 'https://www.redbridge.gov.uk/births-deaths-marriages-civil-partnerships-and-citizenship/ceremonies/',
		},
		{
			text: 'Ceremonies at Redbridge Town Hall',
			url: 'https://www.redbridge.gov.uk/births-deaths-marriages-civil-partnerships-and-citizenship/ceremonies/ceremonies-at-redbridge-town-hall/',
		},
		{
			text: 'Naming ceremonies',
			url: 'https://www.redbridge.gov.uk/births-deaths-marriages-civil-partnerships-and-citizenship/ceremonies/naming-ceremonies/',
		},
		{
			text: 'Fees',
			url: 'https://www.redbridge.gov.uk/births-deaths-marriages-civil-partnerships-and-citizenship/registrars-fees/',
		},
		{
			text: 'Give notice',
			url: 'https://www.redbridge.gov.uk/births-deaths-marriages-civil-partnerships-and-citizenship/give-notice-of-your-marriage-or-civil-partnership/',
		},
	];

	search(term: string) {
		const formatted = term.trim().replace(/\s+/g, '+');
		const url = `https://www.redbridge.gov.uk/search/classic?keyword=${formatted}`;
		window.location.href = url;
	}
}
